module.exports = __webpack_public_path__ + "static/media/qm.9858d6aa.svg";